import { Box, Button, Popover, TextField, Typography } from "@mui/material";
import React from "react";

function TableFilterPopOver({
  open,
  anchorEl,
  callAPI,
  fromDate,
  toDate,
  handleFromDate,
  handleToDate,
  PONumber,
  setPONumber,
  handleClose,
  RCPTNumber,
  setRCPTNumber,
}) {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      <Box sx={{ p: 2 }}>
        <Typography>Filter</Typography>
        {handleFromDate && (
          <TextField
            sx={{ mr: 1 }}
            type="date"
            label="From date"
            value={fromDate}
            onChange={handleFromDate}
            variant="standard"
            InputLabelProps={{
              style: { fontSize: 17 },
            }}
            inputProps={{ style: { fontSize: 12 } }}
          />
        )}
        {handleToDate && (
          <TextField
            sx={{ mr: 1 }}
            type="date"
            label="To date"
            value={toDate}
            onChange={handleToDate}
            variant="standard"
            InputLabelProps={{
              style: { fontSize: 17 },
            }}
            inputProps={{ style: { fontSize: 12 } }}
          />
        )}
        {setPONumber && (
          <TextField
            sx={{ mr: 1 }}
            variant="standard"
            value={PONumber}
            label={"PO Number"}
            onChange={setPONumber}
            InputLabelProps={{
              style: { fontSize: 12 },
            }}
            inputProps={{ style: { fontSize: 12 } }}
          />
        )}
        {setRCPTNumber && (
          <TextField
            sx={{ mr: 1 }}
            variant="standard"
            value={RCPTNumber}
            label={"Receipt Number"}
            onChange={setRCPTNumber}
            InputLabelProps={{
              style: { fontSize: 12 },
            }}
            inputProps={{ style: { fontSize: 12 } }}
          />
        )}
        <Button
          onClick={() => {
            callAPI();
            handleClose();
          }}
          sx={{ fontSize: "12px", mt: 2 }}
        >
          submit
        </Button>
      </Box>
    </Popover>
  );
}

export default TableFilterPopOver;
